module.exports = __webpack_public_path__ + "static/media/5.25d1bf8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/5.svg
// module id = 2837
// module chunks = 3